import { TTopCategory } from '../data';

export const getTopCategoriesId = (topCategories: TTopCategory[]): number[] =>
	topCategories.map(({ topCategoryId }) => topCategoryId);
